// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__AB4xF","select":"Header_select__3XuUD","clinic":"Header_clinic__dCgIP"};